import { createAction, handleActions } from "redux-actions"
import { apiGet, apiPost } from "../utils/apiConnector"
import { measuresApi } from "../config/apiUrls"

const defaultState = {
  measures: [],
}

const setMeasures = createAction("SET_MEASURES")

const reducers = handleActions(
  {
    [setMeasures]: (state, { payload }) => ({
      measures: [...payload],
    }),
  },
  defaultState,
)
export default reducers

export const getMeasures = () => {
  return (dispatch) => {
    apiGet(measuresApi)
      .onOk((res) => {
        dispatch(setMeasures(res.data.response))
      })
      .useDefaultErrorHandlers(dispatch)
      .startSingle()
  }
}

// export function addNewMeasure(data) {
//   return (dispatch) => {
//     apiPost(addMeasureApi, data)
//       .onOk((res) => {
//         dispatch(showMessage(res.data.response, alertTypes.success))
//       })
//       .useDefaultErrorHandlers(dispatch)
//       .startSingle()
//   }
// }
